export default {
  hasLetter: authCode => authCode.match(/[A-Z]/i),
  hasNumber: authCode => authCode.match(/[0-9]/),
  hasSpecialCharacter: authCode => authCode.match(/[!@#$%^&*()_\-+={}\[\]|\/~`?<>:;\\.,']/i),
  hasUpperCaseLetter: authCode => authCode.match(/[A-Z]/),
  hasLowerCaseLetter: authCode => authCode.match(/[a-z]/),
  hasMinCharacters: num => authCode => authCode.length >= num
};
